export default "__VITE_ASSET__CrDMzrUT__"